import { useEffect } from 'react'

function text(value) { return String(value || '').replace(/\s+/g, ' ').trim() }

function renameLabels() {
  document.querySelectorAll('.admin-content dt,.admin-content th,.admin-content span,.admin-content small,.admin-content strong').forEach((node) => {
    const value = text(node.textContent)
    if (value === '회원 ID' || value === '고객 ID') node.textContent = '회원번호'
    if (value === '운영 연결') node.textContent = '거래·정산'
  })
}

function normalizeWon() {
  document.querySelectorAll('.admin-content strong,.admin-content td,.admin-content dd,.admin-content small').forEach((node) => {
    const value = text(node.textContent)
    const match = value.match(/^₩\s*([0-9.]+)M$/i)
    if (match) node.textContent = `${Math.round(Number(match[1]) * 1000000).toLocaleString('ko-KR')}원`
    else if (/^₩[\d,]+$/.test(value)) node.textContent = `${Number(value.replace(/[^\d]/g, '')).toLocaleString('ko-KR')}원`
  })
}

function updateDirectorTabs(route) {
  if (!/^\/directors\/[^/]+$/.test(route)) return
  document.querySelectorAll('.tabs button').forEach((button) => { if (text(button.textContent) === '운영 연결') button.textContent = '거래·정산' })
  const portfolioCard = Array.from(document.querySelectorAll('.card')).find((card) => text(card.querySelector('h2')?.textContent).startsWith('공개 포트폴리오'))
  portfolioCard?.querySelectorAll('button').forEach((button) => { if (text(button.textContent).includes('운영 연결')) button.textContent = '거래·정산 보기' })
  const active = Array.from(document.querySelectorAll('.tabs button')).find((button) => button.classList.contains('active'))
  if (text(active?.textContent) === '거래·정산') {
    document.querySelectorAll('.card').forEach((card) => {
      const title = text(card.querySelector('h2')?.textContent)
      if (['공개 프로필 확장 정보', '자주 묻는 질문', '사진·포트폴리오 운영 연결'].includes(title)) card.style.display = 'none'
      if (title === '관련 거래·운영 이력') { const heading = card.querySelector('h2'); if (heading) heading.textContent = '거래·정산 현황' }
    })
  }
}

function enhanceHomeSelection(route) {
  if (route !== '/content/home') return
  document.querySelectorAll('.admin-modal').forEach((modal) => {
    const title = text(modal.querySelector('h2')?.textContent)
    const chips = modal.querySelector('.admin-chip-list')
    if (chips && !modal.querySelector('[data-selection-search]')) {
      const input = document.createElement('input')
      input.dataset.selectionSearch = 'true'
      input.className = 'admin-selection-search'
      input.placeholder = title.includes('디렉터') ? '디렉터명, 활동명, 서비스 카테고리 검색' : '포트폴리오명, 디렉터명, 카테고리 검색'
      chips.before(input)
      input.addEventListener('input', () => {
        const q = text(input.value).toLowerCase()
        chips.querySelectorAll('button').forEach((button) => { button.style.display = !q || text(button.textContent).toLowerCase().includes(q) ? '' : 'none' })
      })
    }
  })
}

function redirectLegacyRoutes(route) {
  if (route === '/projects') window.location.hash = '#/orders'
  if (route.startsWith('/support/conversations')) window.location.hash = '#/refunds'
}

export default function AdminFlowParityV3() {
  useEffect(() => {
    let queued = false
    const apply = () => {
      const route = (window.location.hash.replace(/^#/, '') || '/').split('?')[0]
      renameLabels()
      normalizeWon()
      updateDirectorTabs(route)
      enhanceHomeSelection(route)
      redirectLegacyRoutes(route)
    }
    const schedule = () => {
      if (queued) return
      queued = true
      queueMicrotask(() => { queued = false; apply() })
    }
    apply()
    const observer = new MutationObserver(schedule)
    observer.observe(document.body, { childList: true, subtree: true })
    window.addEventListener('hashchange', schedule)
    return () => { observer.disconnect(); window.removeEventListener('hashchange', schedule) }
  }, [])
  return null
}
